import React, {useState} from 'react';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import {ReactComponent as CheckCircleIcon} from '../../assets/images/check-circle-icon.svg';
import textFieldStyle from './textFieldComp.module.css';
import {ReactComponent as CopyAll} from '../../assets/images/clipCopy.svg';

const TextFieldComp = ({
  label = '',
  value = '',
  onChange = () => {},
  onBlur = () => {},
  handleClip = () => {},
  row,
  error = false,
  required = false,
  type = 'text',
  name = '',
  placeholder = '',
  fullWidth = true,
  prefix = null,
  minLength,
  maxLength,
  readOnly = false,
  errorMessage,
  disabled = false,
  iconStatus = false,
  multiline = false,
  id,
  onKeyDown,
  inputRef,
  autoComplete = 'off',
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleInputChange = event => {
    if (!event?.target) return;

    let inputValue = event.target.value;
    inputValue = inputValue.trimStart();

    if (inputValue.endsWith('  ')) {
      inputValue = inputValue.replace(/\s+$/, ' ');
    }

    onChange({
      target: {
        name: event.target.name,
        value: inputValue,
      },
    });
  };

  return (
    <Box className={textFieldStyle.textfield_container}>
      <TextField
        label={label}
        value={value}
        rows={row}
        autoComplete={autoComplete}
        onChange={handleInputChange}
        onBlur={onBlur}
        multiline={multiline}
        error={error}
        disabled={disabled}
        required={required}
        type={
          type === 'password'
            ? (showPassword ? 'text' : 'password')
            : type
        }
        name={name}
        placeholder={placeholder}
        fullWidth={fullWidth}
        variant="outlined"
        margin="normal"
        id={id}
        onKeyDown={onKeyDown}
        InputProps={{
          startAdornment: prefix && (
            <InputAdornment
              position="start"
              sx={{marginTop: '1px', opacity: disabled ? 0.5 : 1}}>
              {prefix}
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {type === 'password' && (
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}>
                  {!showPassword ? (
                    <VisibilityOffOutlinedIcon />
                  ) : (
                    <VisibilityOutlinedIcon />
                  )}
                </IconButton>
              )}
              {type === 'clip' && (
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClip}>
                  <CopyAll />
                </IconButton>
              )}
              {iconStatus && (
                <CheckCircleIcon style={{color: 'green', opacity: 0.5}} />
              )}
            </InputAdornment>
          ),
        }}
        inputProps={{
          minLength,
          maxLength,
          readOnly,
          step: type === 'number' ? 0.01 : undefined,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: '8px',
          },
        }}
        inputRef={inputRef}
      />
      {errorMessage && (
        <Box className={`text-regular-12px ${textFieldStyle.error_message}`}>
          {errorMessage}
        </Box>
      )}
    </Box>
  );
};

TextFieldComp.propTypes = {
  inputRef: PropTypes.any,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  fullWidth: PropTypes.bool,
  iconStatus: PropTypes.bool,
  id: PropTypes.any,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  prefix: PropTypes.node,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  type: PropTypes.string,
  autoComplete: PropTypes.string,
  value: PropTypes.string,
  multiline: PropTypes.bool,
  handleClip: PropTypes.any,
  row: PropTypes.any,
  onKeyDown: PropTypes.func,
};

export default TextFieldComp;
